<template>
  <div>
    <search-header :form="searchForm" :formInline="formInline" @on-event="searchEvent"></search-header>
    <Table border :columns="columns" :data="data" :max-height="max_height" :loading="loading"></Table>
    <Page
      class-name="page"
      :total="total"
      size="small"
      show-sizer
      show-total
      show-elevator
      @on-change="changePage"
      @on-page-size-change="changeSize"
    />
    <!--添加模态框-->
     <yn-modal width="585" :flag="add" @on-close="addClose" @on-confirm="addConfirm">
        <span slot="title">添加</span>
        <Form slot="content" ref="addForm" :model="addForm" inline :label-width="100">
        <FormItem label="项目类型" prop="projectType">
          <Select v-model="addForm.projectType" placeholder="项目类型" style="width:160px">
            <Option
              v-for="(item,index) in project_type"
              :value="item.code"
              :key="index"
            >{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="实验室项目名称" prop="name">
          <Input v-model="addForm.labName" placeholder="检验中心名称" style="width:160px"></Input>
        </FormItem>
        <FormItem label="实验室项目编码" prop="name">
          <Input v-model="addForm.labCode" placeholder="检验中心名称" style="width:160px"></Input>
        </FormItem>
        <FormItem label="客户项目名称" prop="name">
          <Input v-model="addForm.hostName" placeholder="检验中心名称" style="width:160px"></Input>
        </FormItem>
        <FormItem label="项目编码" prop="name">
          <Input v-model="addForm.hostCode" placeholder="检验中心名称" style="width:160px"></Input>
        </FormItem>
      </Form>
    </yn-modal>

    <!--编辑模态框-->
    <yn-modal width="585" :flag="editModel" @on-close="editClose" @on-confirm="editConfirm">
      <span slot="title">编辑</span>
      <Form slot="content" ref="editForm" :model="editForm" inline :label-width="100">
      <FormItem label="项目类型" prop="projectType">
          <Select v-model="editForm.projectType" placeholder="项目类型" style="width:160px">
            <Option
              v-for="(item,index) in project_type"
              :value="item.code"
              :key="index"
            >{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="实验室项目名称" prop="name">
          <Input v-model="editForm.labItemName" placeholder="实验室项目" style="width:160px"></Input>
        </FormItem>
        <FormItem label="实验室项目编码" prop="name">
          <Input v-model="editForm.labItemCode" placeholder="实验室项目编码" style="width:160px"></Input>
        </FormItem>
        <FormItem label="客户项目名称" prop="name">
          <Input v-model="editForm.hospitalItemName" placeholder="客户项目" style="width:160px"></Input>
        </FormItem>
        <FormItem label="项目编码" prop="name">
          <Input v-model="editForm.hospitalItemCode" placeholder="项目编码" style="width:160px"></Input>
        </FormItem>
      </Form>
    </yn-modal>
    <!--删除模态框-->
     <yn-modal width="300" :flag="delModal" @on-close="delClose" @on-confirm="delConfirm">
      <span slot="title">删除这条记录</span>
      <p slot="content">确认删除这条记录？</p>
    </yn-modal>
  </div>
</template>
<script>
import SearchHeader from "../../components/SearchHeader";
import YnModal from "../../components/YnModal"
import { $getBrowerHeight,$formatDate,$tips } from "../../tools";
//获取公共的接口
import { dictDataList, provinceList, nextList } from "./../../http/commom";
//获取本页面的接口
import { selectMyMatchListByPage,addMyMatch,delMyMatch,updateMyMatch } from "./../../http/laboratory";
export default {
  components: { SearchHeader ,YnModal},
  data() {
    return {
      add:false,//添加模态框
      editModel:false,//编辑模态框
      delModal:false,//删除模态框
      addForm:{},
      editForm:{},
      id:"",
      current: 1,
      size: 10,
      total: 0,
      max_height: 0,
      loading:true,
      searchLabName:'',//搜索字段
      project_type: [], //项目类型
      relationId: "",
      editId:"",
      delId:"",
      searchForm: [
        {
          fromType: "Input",
          type: "text",
          place: "实验室项目名称",
          value: "labItemName"
        },
        {
          fromType: "Input",
          type: "text",
          place: "客户项目名称",
          value: "hospitalItemName"
        },
        { fromType: "Button", type: "primary", place: "搜索", event: "search" },
        { fromType: "Button", type: "primary", place: "重置", event: "reset" },
        { fromType: "Button", type: "primary", place: "添加", event: "addModel" },
        { fromType: "Button", type: "primary", place: "返回", event: "back" },
      ],
      formInline: {},
      columns: [
        {
          title: "项目类型",
          align:'center',
          key: "projectType",
          minWidth: 100,
          ellipsis: true,
        },
        {
          title: "实验室项目",
          align:'center',
          key: "labItemName",
          minWidth: 100,
          ellipsis: true,
        },
        {
          title: "实验室项目编码",
          align:'center',
          key: "labItemCode",
          minWidth: 100,
          ellipsis: true,
        },
        {
          title: "客户项目",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "hospitalItemName"
        },
        {
          title: "项目编码",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "hospitalItemCode"
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                        this.editModel = true;
                        if(params.row.projectType=="目的项目"){
                          this.editForm.projectType= "0"
                        }else if(params.row.projectType=="结果项目"){
                          this.editForm.projectType= "1"
                        };
                        this.editForm.labItemName = params.row.labItemName;
                        this.editForm.labItemCode = params.row.labItemCode;
                        this.editForm.hospitalItemName = params.row.hospitalItemName;
                        this.editForm.hospitalItemCode = params.row.hospitalItemCode;
                        this.editId=params.row.id
                    }
                  }
                },
                "编辑"
              ),
                h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                       this.delId = params.row.id;
                      this.delModal = true;
                    }
                  }
                },
                "删除"
              ),
            ]);
          }
        }
      ],
      data: [],
      //获取传值
      key:'',
      enabled:null,
      //搜索数据
      searchData:{},
    };
  },
  mounted() {
    this.max_height = this.$getBrowerHeight();
    window.onresize = () => {
      this.max_height = this.$getBrowerHeight();
    };
    this.init();
  },
  methods: {
      //基础数据获取
      init(){
          this.relationId=this.$utils.getUrlKey("id");
          this.id=this.$utils.getUrlKey("id");
          if(this.$utils.getUrlKey("enabled")=='可用'){
            this.enabled=1;
          }else if(this.$utils.getUrlKey("enabled")=='不可用'){
            this.enabled=0;
          }
          //获取缓存值
         this.key= localStorage.getItem("data-center-token");
          //字典
        dictDataList().then(res => {
          this.project_type = res.filter(
          item => item.t === "data_project_type")[0].list;
          this.getList();
        });
      },
      //获取列表
    getList(){
      selectMyMatchListByPage({
        current: this.current,
        enabled: this.enabled,
        hosname: this.searchData.hospitalItemName,
        key: this.key,
        labId:this.id,
        labName: this.searchData.labItemName,
        size: this.size
      }).then(res =>{
        res.records.forEach(item => {
          this.project_type.map(p => {
            if (p.code == item.projectType) {
              item.projectType = p.name;
            }
          });
        });
        this.data = res.records;
        this.total = res.total;
        this.loading = false;
      })
    },
    //搜索组件按钮
    searchEvent(obj) {
      this[obj.type](obj);
    },
    search(obj) {
      this.loading = true;
      this.searchData = obj;
      this.labName=this.searchData.labItemName;
      this.hospitalItemName=this.searchData.hospitalItemName;
      this.getList();
    },
    reset(obj) {
      this.formInline = {};
      this.searchData = {};
      this.getList();
    },
    back(obj) {
      this.$router.go(-1);
    },
    addModel(obj){
      this.add=true;
    },
    //改变页码
    changePage(page) {
      this.loading = true;
      this.current = page;
      this.getList();
    },
    //改变每页显示条数
    changeSize(size) {
      this.loading = true;
      this.size = size;
      this.getList();
    },
    //添加模态框
     addConfirm(){
      addMyMatch({
        hospitalItemCode: this.addForm.hostCode,
        hospitalItemName: this.addForm.hostName,
        labItemCode: this.addForm.labCode,
        labItemName: this.addForm.labName,
        projectType: this.addForm.projectType,
        labid:this.relationId,
        key: this.key,
      }).then(res=>{
        // this.$tips(this, res, "success");
        if(res){
          this.$Message.success('保存成功')
          this.add = false;
          this.loading = true;
          this.getList();
        }
      })
    },
    addClose(){
        this.add = false;
    },
    //编辑模态框
    editClose(){
      this.editModel = false;
    },
     editConfirm(){
        updateMyMatch({
          id:this.editId,
          labid: this.relationId,
          hospitalItemCode: this.editForm.hospitalItemCode,
          hospitalItemName: this.editForm.hospitalItemCode,
          labItemCode: this.editForm.labItemCode,
          labItemName: this.editForm.labItemName,
          projectType: this.editForm.projectType,
          key: this.key,
        }).then(res =>{
          // this.$tips(this,res,'success')
          this.$Message.success('修改成功')
          this.editModel = false;
          this.loading = true;
          this.getList();
        })
    },
    //删除
    delClose(){
      this.delModal = false;
    },
    delConfirm(){
      delMyMatch({id:this.delId}).then(res =>{
        this.delModal = false;
        // this.$tips(this,res,"success")
        this.$Message.error('删除成功')
        this.loading = true;
        this.getList();
      })
    },
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/laboratoryMap/laboratoryMap.vue